import { api } from '../middleware/api';

export interface AmProduct {
  pt_id?: number;
  pt_company?: string;
  pt_code: string;
  pt_name: string;
  pt_category: number | null;
  pt_uom?: string;
  pt_brand?: string;
  pt_model?: string;
  pt_cost?: number;
  pt_depmethod?: 'S' | 'W';
  pt_deprate?: number | null;
  pt_usefullife?: number | null;
  pt_salvagevalue?: number;
  pt_warranty_months?: number | null;
  pt_active?: '0' | '1';
  category_name?: string;
}

export const amproductApi = api
  .enhanceEndpoints({ addTagTypes: ['AmProduct'] })
  .injectEndpoints({
    endpoints: builder => ({
      getAmProducts: builder.query<AmProduct[], void>({
        query: () => 'amproduct',
        providesTags: ['AmProduct']
      }),
      // The API saves (insert or update) through a single POST; pt_id > 0 updates
      saveAmProduct: builder.mutation<{ pt_id: number }, AmProduct>({
        query: body => ({ url: 'amproduct', method: 'POST', body }),
        invalidatesTags: ['AmProduct']
      }),
      deleteAmProduct: builder.mutation<{ message: string }, number>({
        query: id => ({ url: `amproduct/${id}`, method: 'DELETE' }),
        invalidatesTags: ['AmProduct']
      })
    }),
    overrideExisting: false
  });

export const { useGetAmProductsQuery, useSaveAmProductMutation, useDeleteAmProductMutation } = amproductApi;
